import { TFunction } from 'i18next'
import { z } from 'zod'

import { URL_REGEX } from '@/constants/regex'
import { SocialLinkService } from '@/models'

import { ServiceOption } from './social-links.types'

export const SocialLinkServiceSchema = z.enum([
  'google',
  'yelp',
  'apartments',
  'apartmentratings',
  'facebook',
])

export const makeSocialLinkFormSchema = (t: TFunction<['communication']>) =>
  z.object({
    link: z
      .string()
      .min(1, t('communication:socialLinks.form.link.validation.required'))
      .regex(URL_REGEX, t('communication:socialLinks.form.link.validation.invalid')),
    service: SocialLinkServiceSchema,
  })

export const getServiceOptions = (t: TFunction<['communication']>): ServiceOption[] => [
  { label: t('communication:socialLinks.service.options.google'), value: 'google' },
  { label: t('communication:socialLinks.service.options.apartments'), value: 'apartments' },
  { label: t('communication:socialLinks.service.options.yelp'), value: 'yelp' },
  {
    label: t('communication:socialLinks.service.options.apartmentratings'),
    value: 'apartmentratings',
  },
  { label: t('communication:socialLinks.service.options.facebook'), value: 'facebook' },
]

export const getServiceLabelMap = (
  t: TFunction<['communication']>,
): Record<SocialLinkService, string> => ({
  apartmentratings: t('communication:socialLinks.service.options.apartmentratings'),
  apartments: t('communication:socialLinks.service.options.apartments'),
  facebook: t('communication:socialLinks.service.options.facebook'),
  google: t('communication:socialLinks.service.options.google'),
  yelp: t('communication:socialLinks.service.options.yelp'),
})

export const SERVICE_ICON_MAP: Record<SocialLinkService, string> = {
  apartmentratings: '/images/socials/raitings-icon.png',
  apartments: '/images/socials/apartments-icon.png',
  facebook: '/images/socials/facebook-icon.png',
  google: '/images/socials/google-icon.png',
  yelp: '/images/socials/yelp-icon.png',
}
